"use client";

import type React from "react";
import { useState, useCallback } from "react";
import { FormControl, FormLabel, Input, useToast, Box } from "@chakra-ui/react";
import { agentService } from "../../services/agentService.ts";
import { useAppTheme } from "../../ThemeContext.tsx";

interface CustomLLMUrlInputProps {
  agentId: string;
  initialUrl: string;
}

export const CustomLLMUrlInput: React.FC<CustomLLMUrlInputProps> = ({
  agentId,
  initialUrl,
}) => {
  const [llmWebsocketUrl, setLlmWebsocketUrl] = useState(initialUrl);
  const toast = useToast();
  const { resolvedTheme } = useAppTheme();
  const isDark = resolvedTheme === "dark";

  const handleSaveUrl = useCallback(async () => {
    try {
      await agentService.update(agentId, {
        response_engine: {
          type: "custom-llm",
          llm_id: "custom",
          llm_websocket_url: llmWebsocketUrl,
        },
      });
      toast({
        title: "Custom LLM URL saved successfully",
        status: "success",
        duration: 3000,
      });
    } catch (err: any) {
      console.error(err);
      toast({
        title: "Error saving Custom LLM URL",
        description: err.message,
        status: "error",
        duration: 5000,
      });
    }
  }, [agentId, llmWebsocketUrl, toast]);

  return (
    <Box mb={4}>
      <FormControl>
        <FormLabel fontWeight="bold" color={isDark ? "white" : "gray.800"}>
          Custom LLM URL
        </FormLabel>
        <Input
          value={llmWebsocketUrl}
          onChange={(e) => setLlmWebsocketUrl(e.target.value)}
          onBlur={handleSaveUrl}
          placeholder="https://replace-with-your-llm-url.com"
          bg={isDark ? "gray.800" : "white"}
          border="none"
          _focus={{
            border: isDark
              ? "1px solid rgb(255, 255, 255)"
              : "1px solid rgb(0, 0, 0)",
            boxShadow: isDark
              ? "1px solid rgb(255, 255, 255)"
              : "1px solid rgb(0, 0, 0)",
          }}
          _hover={{
            border: isDark
              ? "1px solid rgb(200, 200, 200)"
              : "1px solid rgb(100, 100, 100)",
          }}
          fontSize="sm"
        />
      </FormControl>
    </Box>
  );
};
